// extracted by mini-css-extract-plugin
export default {"label":"w8EIN5G8lfCUmScLGdPT","selected":"kqdy3F39LcKV9LUBhexz"};